import React from 'react';
import { Dropdown, Anchor } from 'react-bootstrap';
import { TwitterIcon, TwitterShareButton } from 'react-share';
import TwitterShare from './twitterShare';
import OpenSeaLink from './openSeaLink';
//adding new campaign page
const SharedActions = ({
  openseaLink = '',
  tweetTitle,
  tweetLink,
  className = '',
}) => {
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {/* custom icon */}
      {children}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        fill="currentColor"
        className="bi bi-three-dots-vertical"
        viewBox="0 0 16 16"
        id="IconChangeColor"
      >
        <path
          d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
          id="mainIconPathAttribute"
          fill="#00998f"
          strokeWidth="0"
          stroke="#ff0000"
        ></path>
      </svg>
    </a>
  ));

  return (
    <Dropdown className={` ml-2 shared-actions-dropdown ${className}`}>
      <Dropdown.Toggle as={CustomToggle}></Dropdown.Toggle>
      <Dropdown.Menu size="sm" title="">
        <Dropdown.Header>ِActions</Dropdown.Header>
        {openseaLink != '' && (
          <Dropdown.Item as={Anchor} href={openseaLink}>
            <OpenSeaLink openseaLink={openseaLink} />
          </Dropdown.Item>
        )}
        <Dropdown.Item>
          <TwitterShare tweetLink={tweetLink} tweetTitle={tweetTitle} />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SharedActions;
